import { Reviewer } from "components/Submission/ReviewersEditList";
import { ReviewMode } from "generated-graphql/graphql";
import { SubmissionReviewerSigner } from "hooks/useSubmissionForm";
import { useState } from "react";

/** Open/closed state for every dialog on the Reviewer Preparation step. */
export function useReviewerPreparationDialogState() {
  const [reviewerDialogOpen, setReviewerDialogOpen] = useState(false);
  const [signerDialogOpen, setSignerDialogOpen] = useState(false);
  const [preparationDialogOpen, setPreparationDialogOpen] = useState(false);
  const [advanceConfirmOpen, setAdvanceConfirmOpen] = useState(false);
  const [finalApprovalReviewers, setFinalApprovalReviewers] = useState<Reviewer[] | null>(null);
  // Signer/reviewer mutual-exclusion confirmations (one person can't be both).
  // The pending save carries its review mode so confirming applies exactly what
  // the dialog chose, not just the reviewer list.
  const [reviewersToConfirm, setReviewersToConfirm] = useState<{
    reviewers: Reviewer[];
    reviewMode: ReviewMode;
  } | null>(null);
  const [signerToConfirm, setSignerToConfirm] = useState<SubmissionReviewerSigner | null>(null);
  // Names the approved reviewers a pending save would drop, plus what to run on
  // confirm — the same save can be reached from Save or from Send.
  const [droppedApprovalsToConfirm, setDroppedApprovalsToConfirm] = useState<{
    names: string[];
    proceed: () => void;
  } | null>(null);

  return {
    droppedApprovalsToConfirm,
    setDroppedApprovalsToConfirm,
    reviewerDialogOpen,
    setReviewerDialogOpen,
    signerDialogOpen,
    setSignerDialogOpen,
    preparationDialogOpen,
    setPreparationDialogOpen,
    advanceConfirmOpen,
    setAdvanceConfirmOpen,
    finalApprovalReviewers,
    setFinalApprovalReviewers,
    reviewersToConfirm,
    setReviewersToConfirm,
    signerToConfirm,
    setSignerToConfirm,
  };
}
